export default function Style(){
  return (
    <style>
      {`
         .fs-36-45 {
   font-size: 28px !important;
   line-height: 35px !important;
 }

 .fs-20-30 {
   font-size: 18px !important;
   line-height: 27px !important;
 }
@media screen and (min-width: 768px) {
  .fs-36-45 {
    font-size: 30px !important;
    line-height: 38px !important;
  }

  .fs-16-res {
    font-size: 16px !important;
    line-height: 24px !important;
  }
}

@media screen and (min-width: 1280px) {
   .fs-36-45 {
     font-size: 32px !important;
     line-height: 40px !important;
   }
 
  .fs-16-res {
    font-size: 16px !important;
    line-height: 24px !important;
  }
}

@media screen and (min-width: 1543px) {
  .fs-36-45 {
    font-size: 36px !important;
    line-height: 45px !important;
  }

  .fs-16-res {
    font-size: 18px !important;
    line-height: 27px !important;
  }
  .fs-20-30{
    font-size: 20px !important;
    line-height: 30px !important;
  }
}

        
        `}
    </style>
  );
}
